import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import PageTitle from '../../Component/Page/PageTitle';
import { getPostList, getTerms } from '../../service';
import ParticipationContentList from './ParticipationContentList/ParticipationContentList';
import ParticipationSubMenu from './ParticipationSubMenu';

type Props = {
  params: any;
};

function Participation({ params }: Props) {

  const { isLoading, error, data } = useQuery('participationTop', () => getTerms('participation_category'));
  const [current, setCurrent] = useState({} as any);
  const [subCategory, setSubCategory] = useState([] as any[]);

  const { isLoading: isCategoryLoading, error: categoryError, data: categoryData } = useQuery('participationCategory', () => getPostList('participation', 'participation_category', params.first, -1, 'ASC'));

  useEffect(() => {
    if (data === undefined) {
      return;
    }
    const currentTerm = data.filter((item: any) => item.slug === params.first)[0];
    setCurrent(currentTerm);

    const subCategory = data.filter((item: any) => item.parent === currentTerm.term_id).map((item: any) => {
      return {
        title: item.name,
        slug: item.slug,
        meta: {
          participation_slug: item.slug.replace('-','')
        }
      }
    });
    
    setSubCategory(subCategory);    
  }, [data, params.first]);

  const isEnglish = window.__LANG__ === 'en';

  return (
    <>
    {
      !isLoading && !error && data && current && (
        <PageTitle
          type="big"
          bgPath={`participation/top${current.slug}.jpg`}
          title={isEnglish ? current?.meta?.participation_category_en_title : current.name}
          subtitle={isEnglish ? current?.meta?.participation_category_en_parent_title :current?.meta?.participation_category_parent_text}
          description={isEnglish ? current?.meta?.participation_category_en_desc[0] : current?.description}
        />
      )
    }
    
    {
      !isCategoryLoading && !categoryError && categoryData && !isLoading && data && !isEnglish && (
        <ParticipationSubMenu data={subCategory.length !== 0 ? subCategory : categoryData} term={params.first} slug={params.second} />
      )
    }

    <ParticipationContentList term={params.first} slug={params.second} />
    </>
  );
}

Participation.defaultProps = {
};

export default Participation;
